import moment from "moment";
import { decode } from "base64-arraybuffer";

export const FETCH_ATTACHMENTS = "FETCH_ATTACHMENTS";
export const FETCH_FOLLOWUP_ATTACHMENTS = "FETCH_FOLLOWUP_ATTACHMENTS";
export const FETCH_ATTACHMENTS_SUCCEDED = "FETCH_ATTACHMENTS_SUCCEDED";
export const FETCH_FOLLOWUP_ATTACHMENTS_SUCCEDED = "FETCH_FOLLOWUP_ATTACHMENTS_SUCCEDED";
export const FETCH_FOLLOWUP_ATTACHMENTS_FAILED = "FETCH_FOLLOWUP_ATTACHMENTS_FAILED";
export const FETCH_ATTACHMENTS_FAILED = "FETCH_ATTACHMENTS_FAILED";

export const SET_FILES_TO_UPLOAD = "SET_FILES_TO_UPLOAD";
export const SET_FILE_UPLOAD_RES = "SET_FILE_UPLOAD_RES";
export const FILE_UPLOAD_AUDIT_ACTIVITY = "FILE_UPLOAD_AUDIT_ACTIVITY";

export const UPDATE_ATTACHMENTS = "UPDATE_ATTACHMENTS";
export const SET_FILE_UPDATE_RES = "SET_FILE_UPDATE_RES";
export const FILE_UPDATE_AUDIT_ACTIVITY = "FILE_UPDATE_AUDIT_ACTIVITY";

export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";

export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const CLEAR_ATTACHMENTS = "CLEAR_ATTACHMENTS";
export const fetchAttachments = (workOrderNumber) => {
    return {
        type: FETCH_ATTACHMENTS,
        workOrderNumber,
    };
};

export const fetchFollowUpAttachments = (workOrderNumber) => {
    return {
        type: FETCH_FOLLOWUP_ATTACHMENTS,
        workOrderNumber,
    };
};

export const setFilesToUpload = (files) => {
    return {
        type: SET_FILES_TO_UPLOAD,
        filesToUpload: files,
    };
};

const formatFiles = (files) => {
    var re = /(.+?)(?:\.([^.]+))?$/; // Captures file name and extension, if there
    var formattedFiles = files.map((f) => {
        var match = re.exec(f.fileName);
        var fileNameNoExt = match && match[1] ? match[1] : "";
        var extension = match && match.length === 3 ? match[2] : "";
        var file = {
            id: f.id,
            fileName: f.fileName,
            fullFileName: f.fileName,
            fileNameNoExt,
            size: decode(f.data).byteLength,
            fileDescription: f.fileDescription,
            data: f.data,
            fileType: f.fileType,
            extension,
            createdDateTime: moment(new Date(f.createdDateTime + "+00:00")),
            relatedJobId: f.relatedJobId,
            relatedSourceId: f.relatedSourceId,
            uploadedBy: f.uploadedBy,
        };
        return file;
    });

    return formattedFiles;
};

export const fetchAttachmentsSucceeded = (files) => {
    var formattedFiles = formatFiles(files);

    return {
        type: FETCH_ATTACHMENTS_SUCCEDED,
        workOrderAttachments: formattedFiles,
    };
};

export const fetchAttachmentsFailed = () => {
    return {
        type: FETCH_ATTACHMENTS_FAILED,
    };
};

export const fetchFollowupAttachmentsSucceeded = (files, workOrderNumber) => {
    var formattedFiles = formatFiles(files);

    return {
        type: FETCH_FOLLOWUP_ATTACHMENTS_SUCCEDED,
        attachments: formattedFiles,
        workOrderNumber: workOrderNumber,
    };
};

export const fetchFollowupAttachmentsFailed = () => {
    return {
        type: FETCH_FOLLOWUP_ATTACHMENTS_FAILED,
    };
};

export const updateAttachments = (filesToUpdate) => {
    return {
        type: UPDATE_ATTACHMENTS,
        filesToUpdate,
    };
};

export const uploadAttachments = (filesToUpload) => {
    return {
        type: UPLOAD_ATTACHMENTS,
        filesToUpload,
    };
};

export const removeAttachment = (fileToRemove) => {
    return {
        type: DELETE_ATTACHMENT,
        fileToRemove,
    };
};

export const clearAttachments = () => {
    return {
        type: CLEAR_ATTACHMENTS,
    };
};

export const fileUploadResponse = (response) => {
    return {
        type: SET_FILE_UPLOAD_RES,
        response,
    };
};

export const fileUpdateResponse = (response) => {
    return {
        type: SET_FILE_UPDATE_RES,
        response,
    };
};

export const fileUploadAuditActivity = (payload) => {
    return {
        type: FILE_UPLOAD_AUDIT_ACTIVITY,
        payload,
    };
};

export const fileUpdateAuditActivity = (payload) => {
    return {
        type: FILE_UPDATE_AUDIT_ACTIVITY,
        payload,
    };
};
